const e = "LeadFormDataService";
export {
  e as LEAD_FORM_DATA_SERVICE
};
